import React, { forwardRef } from 'react';

import { Body } from './components';
import { Container, Footer, Header } from './Card.styles';
import { Border, Color, Variant } from './types';

export interface CardProps {
  /**
   * Component variant
   */
  variant?: Variant;
  /**
   * Component color variant
   */
  color?: Color;
  /**
   * Indicator for header border, by default it is set to `true`
   */
  enableBorder?: boolean;
  /**
   * Border variant, by default it is set to rounded
   */
  border?: Border;
  /**
   * Children nodes
   */
  children: React.ReactNode;
}

/**
- The Card component works as a container and exposes Header, Body and Footer elements.
**/
const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    { variant = 'regular', color = 'white', border = 'rounded', children },
    ref
  ) => (
    <Container variant={variant} color={color} border={border} ref={ref}>
      {children}
    </Container>
  )
);
Card.displayName = 'Card';

export default Object.assign(Card, {
  Header,
  Body,
  Footer,
});
